import {
    ACCOUNT_MEMBER_INVITE,
    ACCOUNT_MEMBER_INVITE_FAIL,
    ACCOUNT_MEMBER_INVITE_RESET,
    ACCOUNT_MEMBER_INVITE_SET_PARAMS,
    ACCOUNT_MEMBER_INVITE_SUCCESS,
} from './constants';

//
export const AccountMemberInviteReducer = (state, action) => {
    let ret = {
        ...state,
        idKey: Math.random()
    }
    const data = action.payload;
    switch (action.type) {
        case ACCOUNT_MEMBER_INVITE_RESET:
            ret.laoding = false;
            ret.error = null;
            ret.loadSuccess = null;
            ret.loadDatas = null;
            ret.params = null;
            break;
        case ACCOUNT_MEMBER_INVITE_SET_PARAMS:
            ret.params = data.params;
            break;
        case ACCOUNT_MEMBER_INVITE:
            ret.loading = true;
            ret.params = data.params;
            ret.loadSuccess = null;
            ret.loadDatas = null;
            break;
        case ACCOUNT_MEMBER_INVITE_SUCCESS:
            ret.loading = false;
            ret.loadSuccess = true;
            ret.loadDatas = data.loadDatas;
            break;
        case ACCOUNT_MEMBER_INVITE_FAIL:
            ret.loading = false;
            ret.error = data;
            ret.loadSuccess = false;
            break;
        default:
            return {...state};
    }
    return ret;
}
